import React, { Fragment } from 'react';
import moment from 'moment-timezone';

const TIMESTAMP_FORMAT = 'MM/DD/YYYY, h:mm:ss A z';
const FIRST_LINE_FORMAT = 'MM/DD/YYYY';
const SECOND_LINE_FORMAT = 'h:mm:ss A z';

export function formatISOTimestamp(timestamp: string, twoLines = false): React.ReactNode {
  // The moment.tz.guess() is required because of this: https://github.com/moment/moment/issues/162#issuecomment-182539707
  const localizedTimestamp = moment(timestamp).tz(moment.tz.guess());

  // Format with a line break and small second line, if applicable
  return twoLines ? (
    <Fragment>
      {localizedTimestamp.format(FIRST_LINE_FORMAT)}
      <br />
      <small>{localizedTimestamp.format(SECOND_LINE_FORMAT)}</small>
    </Fragment>
  ) : localizedTimestamp.format(TIMESTAMP_FORMAT);
}

export function isDateStringValid(dateString: string): boolean {
  // See https://docs.djangoproject.com/en/dev/ref/settings/#std:setting-DATE_INPUT_FORMATS
  const ALLOWED_DATE_FORMATS = ["YYYY-MM-DD", "MM/DD/YYYY", "MM/DD/YY"];
  return moment(dateString, ALLOWED_DATE_FORMATS, true).isValid();
}
